module.exports = "/_next/static/images/footer2-c89c46d5341a1620ce6056ef992486d9.svg";